import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import CustomerMetaFieldService from "../../../services/OrderingServices/CustomerMetaFieldService";
import StatusBadge from "../../../Components/Common/Badge";

const CustomerMetaFieldViewModal = ({ isOpen, toggle, selectedId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && selectedId) {
      fetchDetail();
    } else {
      setData(null);
    }
  }, [isOpen, selectedId]);

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const res = await CustomerMetaFieldService.getDetail(selectedId);
      setData(res);
    } catch (error) {
      console.error("Error fetching detail:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className="border-bottom">
        <i className="ri-information-line me-2 text-primary"></i>
        Customer Meta Field Details
      </ModalHeader>
      <ModalBody className="p-4">
        {loading ? (
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p className="mt-2 text-muted">Fetching details...</p>
          </div>
        ) : data ? (
          <Row className="g-4">
            <Col md={12}>
              <label className="text-muted small text-uppercase fw-bold mb-1">Title</label>
              <h5 className="fw-bold">{data.title || "-"}</h5>
            </Col>
            <Col md={6}>
              <label className="text-muted small text-uppercase fw-bold mb-1">Code</label>
              <p className="mb-0 fw-medium">{data.code || "-"}</p>
            </Col>
            <Col md={6}>
              <label className="text-muted small text-uppercase fw-bold mb-1">Status</label>
              <div>
                <StatusBadge status={data.isActive} type="status" pill={true} />
              </div>
            </Col>
            <Col md={12}>
              <label className="text-muted small text-uppercase fw-bold mb-1">Description</label>
              <div className="p-3 bg-light rounded-2" style={{ whiteSpace: "pre-wrap" }}>
                {data.description || "No description provided."}
              </div>
            </Col>
          </Row>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted">No data found</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter className="border-top">
        <Button color="light" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomerMetaFieldViewModal;
